import "./App.scss";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/appLayout/Layout";
import { HomePage } from "./pages/homePage";
import PrivacyPolicy from "./pages/policy";
import CookiesPolicy from "./pages/coockies";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <ToastContainer position="top-right" />
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <HomePage />
              </Layout>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <Layout>
                <PrivacyPolicy />
              </Layout>
            }
          />
          <Route
            path="/cookies-policy"
            element={
              <Layout>
                <CookiesPolicy />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
